import axios from 'axios';
import { setupInterceptors } from './api-admin-interceptors';

let API_V3 = axios.create({
  baseURL: `${process.env.VUE_APP_API}/api/v3/private/`,
  headers: {
    Accept: 'application/ld+json',
    'Content-Type': 'application/ld+json',
  },
});

setupInterceptors(API_V3);

export default API_V3;
